<template>
  <div class="recharge-first">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <!-- 这是黑色返回箭头 -->
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="recharge-content">
      <img v-if="$i18n.locale === 'ar'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-ar')" alt="" />
      <img v-else-if="$i18n.locale === 'es'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-es')" alt="" />
      <img v-else-if="$i18n.locale === 'fr'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-fr')" alt="" />
      <img v-else-if="$i18n.locale === 'id'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-id')" alt="" />
      <img v-else-if="$i18n.locale === 'pt'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-pt')" alt="" />
      <img v-else-if="$i18n.locale === 'tr'" class="rec-fir-tit" :src="getMatchTitle('tit-bg-tr')" alt="" />
      <img v-else class="rec-fir-tit" :src="getMatchTitle('tit-bg-en')" alt="" />
      <div class="rec-date-block">
        <div class="rec-fir-date">
          <span>{{ $t('lang.ActCommon.k003') }}</span>
          <img src="./images/clock.webp" />
          <span>{{ showTime }}</span>
        </div>
      </div>

      <div class="rec-fir-con">
        <div class="rec-fir-head">{{ $t('lang.RechargeLowSmall.k001') }}</div>
        <div class="rec-fir-block">
          <div class="rec-fir-reward">
            <div class="fir-reward-l">
              <span v-if="baseInfo" class="fir-reward-num">{{ baseInfo.originAmount }}</span>
              <img class="fir-reward-coin" :src="getMatchImg('coin')" alt="" />
              <span class="fir-reward-tit">{{ $t('lang.ActCommon.k050') }}</span>
            </div>
            <img class="fir-reward-c" src="./images/up-t.webp" />
            <div class="fir-reward-r">
              <span v-if="baseInfo" class="fir-reward-num">
                {{ baseInfo.originAmount }}
                <i>+{{ baseInfo.amount - baseInfo.originAmount }}</i>
              </span>
              <img class="fir-reward-coin" :src="getMatchImg('coin')" alt="" />
              <div class="fir-reward-tit">{{ $t('lang.ActCommon.k051') }}</div>

              <div v-if="baseInfo" class="reward-percent">+{{ baseInfo.discountDesc }}</div>
            </div>
          </div>

          <div class="rec-fir-deliver">
            <div class="deliver-l">
              <div></div>
            </div>
            <div class="rec-fir-deliver-text">{{ $t('lang.ActCommon.k004') }}</div>
            <div class="deliver-r">
              <div></div>
            </div>
          </div>

          <div v-if="baseInfo && baseInfo.presentPropList && baseInfo.presentPropList.length" class="rec-fir-fecture">
            <template v-for="(item, index) in baseInfo.presentPropList">
              <div v-if="index > 0" class="fir-fecture-gap"></div>

              <div v-if="item.propType == 1" class="fir-fecture-item">
                <img :src="getMatchImg('chat-pass')" />
                <div>x{{ item.number }}</div>
              </div>
              <div v-else-if="item.propType == 2" class="fir-fecture-item">
                <img :src="getMatchImg('video-pass')" />
                <div>x{{ item.number }}</div>
              </div>
              <div v-else-if="item.propType == 4" class="fir-fecture-item">
                <img :src="getMatchImg('vip')" />
                <div>x{{ item.number }}</div>
              </div>
              <div v-else-if="item.propType == 6" class="fir-fecture-item">
                <img :src="getMatchImg('call-pass')" />
                <div>x{{ item.number }}</div>
              </div>
              <div v-else-if="item.propType == 9" class="fir-fecture-item">
                <img :src="getMatchImg('coupon')" />
                <div>x{{ item.number }}</div>
              </div>
              <div v-else-if="item.propType == 15" class="fir-fecture-item">
                <img :src="getMatchImg('super-chat-pass')" />
                <div>x{{ item.number }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-if="baseInfo" class="rec-fir-btn" :class="{ 'cannot-claim': !baseInfo || !baseInfo.ifValid }" @click="handleClaim">
      <div v-if="baseInfo.currencyIcon" class="btn-icon">
        <img :src="baseInfo.currencyIcon | imgPath" />
      </div>
      &nbsp;
      <span>{{ baseInfo.currency }}{{ handleDiv100(baseInfo.originPrice) }}</span>
    </div>

    <ul class="rec-fir-tip">
      <li>
        <MyPLabel :str="$t('lang.ActCommon.k006')" :numsOption="[{ value: specialCount }]" />
      </li>
    </ul>
  </div>
</template>

<script>
import { lowSmallRechargeApi } from './apidir/api.js'
import { compareVersion } from '@/utils/common.js'

// en
import vavaTitBgEn from './images/vava/bg-en.webp'
import echoTitBgEn from './images/echo/bg-en.webp'
import joychatTitBgEn from './images/joychat/bg-en.webp'
import kikoTitBgEn from './images/kiko/bg-en.webp'

// ar
import vavaTitBgAr from './images/vava/bg-ar.webp'
import echoTitBgAr from './images/echo/bg-ar.webp'
import joychatTitBgAr from './images/joychat/bg-ar.webp'
import kikoTitBgAr from './images/kiko/bg-ar.webp'

// es
import vavaTitBgEs from './images/vava/bg-es.webp'
import echoTitBgEs from './images/echo/bg-es.webp'
import joychatTitBgEs from './images/joychat/bg-es.webp'
import kikoTitBgEs from './images/kiko/bg-es.webp'

// fr
import vavaTitBgFr from './images/vava/bg-fr.webp'
import echoTitBgFr from './images/echo/bg-fr.webp'
import joychatTitBgFr from './images/joychat/bg-fr.webp'
import kikoTitBgFr from './images/kiko/bg-fr.webp'

// id
import vavaTitBgId from './images/vava/bg-id.webp'
import echoTitBgId from './images/echo/bg-id.webp'
import joychatTitBgId from './images/joychat/bg-id.webp'
import kikoTitBgId from './images/kiko/bg-id.webp'

// pt
import vavaTitBgPt from './images/vava/bg-pt.webp'
import echoTitBgPt from './images/echo/bg-pt.webp'
import joychatTitBgPt from './images/joychat/bg-pt.webp'
import kikoTitBgPt from './images/kiko/bg-pt.webp'

// tr
import vavaTitBgTr from './images/vava/bg-tr.webp'
import echoTitBgTr from './images/echo/bg-tr.webp'
import joychatTitBgTr from './images/joychat/bg-tr.webp'
import kikoTitBgTr from './images/kiko/bg-tr.webp'

export default {
  data() {
    return {
      appInfo: null,
      // 倒计时
      lastTime: 0,
      endTime: 0,
      showTime: '00:00:00',
      // 随机count
      specialCount: 10908,
      baseInfo: null,
      matchPassExtra: 0,
      superChatPassExtra: 0,
    }
  },
  methods: {
    getMatchTitle(imgname) {
      const imgsMap = {
        'tit-bg-ar': {
          vava: vavaTitBgAr,
          echo: echoTitBgAr,
          joychat: joychatTitBgAr,
          kiko: kikoTitBgAr,
        },
        'tit-bg-en': {
          vava: vavaTitBgEn,
          echo: echoTitBgEn,
          joychat: joychatTitBgEn,
          kiko: kikoTitBgEn,
        },
        'tit-bg-es': {
          vava: vavaTitBgEs,
          echo: echoTitBgEs,
          joychat: joychatTitBgEs,
          kiko: kikoTitBgEs,
        },
        'tit-bg-fr': {
          vava: vavaTitBgFr,
          echo: echoTitBgFr,
          joychat: joychatTitBgFr,
          kiko: kikoTitBgFr,
        },
        'tit-bg-id': {
          vava: vavaTitBgId,
          echo: echoTitBgId,
          joychat: joychatTitBgId,
          kiko: kikoTitBgId,
        },
        'tit-bg-pt': {
          vava: vavaTitBgPt,
          echo: echoTitBgPt,
          joychat: joychatTitBgPt,
          kiko: kikoTitBgPt,
        },
        'tit-bg-tr': {
          vava: vavaTitBgTr,
          echo: echoTitBgTr,
          joychat: joychatTitBgTr,
          kiko: kikoTitBgTr,
        },
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('kiko', appName)) {
        return imgsMap[imgname]['kiko']
      }
    },
    handleClaim() {
      if (!this.baseInfo || !this.baseInfo.ifValid) {
        return
      }
      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        activityType: 12,
        gid: this.baseInfo.gid,
        productId: this.baseInfo.productId,
        amount: this.baseInfo.amount,
        backType: 'previous',
      }

      // price currency参数控制 原生支付的显示
      // 下面这些版本之后，payGoogleFromWeb 才支持服务端需要回传的avtivityType
      let appChannel = ''
      try {
        appChannel = this.getChannel()
        if (appChannel === 'vvg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '4.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        if (appChannel === 'jcg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '2.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        if (appChannel === 'eca') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        if (appChannel === 'ecg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        // kiko
        if (appChannel === 'kkg') {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      } catch (err) {
        console.error(err)
      }

      this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'low-small-recharge-click-claim' })

      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery,
        })
        return
      }

      this.$router.push({
        path: '/pay',
        query: payQuery,
      })
    },
    // 获得页面数据
    initData() {
      lowSmallRechargeApi().then((resData) => {
        if (resData && !resData.error) {
          this.baseInfo = resData

          if (this.baseInfo && this.baseInfo.presentPropList && this.baseInfo.presentPropList.length) {
            const matchObj = this.baseInfo.presentPropList.find((ele) => ele.propType === 2)
            if (matchObj) {
              this.matchPassExtra = matchObj.number
            }

            const superObj = this.baseInfo.presentPropList.find((ele) => ele.propType === 15)
            if (superObj) {
              this.superChatPassExtra = superObj.number
            }
          }
          // 初始化倒计时
          try {
            const now = Date.now()
            this.endTime = now + resData.expireSeconds * 1000
            this.startCountdown(now)
          } catch (err) {
            this.showTime = ''
          }
        }
      })
    },
    refreshData() {
      if (this.baseInfo) {
        this.baseInfo.ifValid = false
      }
    },
    initRandomCount() {
      // 30分钟
      const intervalTime = 1800000
      // const intervalTime = 3000
      const uid = this.getUid()
      const loop = () => {
        // 10908-20908
        let random = Math.floor((Math.random() + 1) * 10000) + 908
        let nowTime = Date.now()

        let storeObj = window.localStorage.getItem(`specialCount${uid}`)
        // 有缓存
        if (storeObj) {
          try {
            storeObj = JSON.parse(storeObj)
            random = storeObj.count * 1
            nowTime = storeObj.time * 1

            const currentTime = Date.now()
            if (currentTime - nowTime >= intervalTime) {
              let willNum = random + 118
              if (willNum > 99999) {
                willNum = 100000
              }
              window.localStorage.setItem(`specialCount${uid}`, JSON.stringify({ count: willNum, time: currentTime }))
            }
          } catch (err) {
            console.log('try catch', err)
          }
        }
        // 没缓存
        else {
          window.localStorage.setItem(`specialCount${uid}`, JSON.stringify({ count: random, time: nowTime }))
        }

        this.specialCount = random > 99999 ? '99999+' : random

        setTimeout(() => {
          loop()
        }, 10000)
      }

      loop()
    },
    startCountdown() {
      const countdownFn = (currentTime) => {
        // 避免过于频繁的更新
        if (currentTime - this.lastTime >= 1000) {
          const remainingTime = this.endTime - Date.now()

          if (remainingTime <= 0) {
            this.showTime = '00:00:00'
            this.refreshData()
            return
          }

          this.showTime = `${this.formatTime(remainingTime)}`
          this.lastTime = currentTime
        }

        // 继续下一帧
        this.animationFrameId = requestAnimationFrame(countdownFn)
      }

      this.animationFrameId = requestAnimationFrame(countdownFn)
    },
    // 格式化时间显示
    formatTime(ms) {
      if (ms <= 0) return '00:00:00'

      const totalSeconds = Math.floor(ms / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.initData()
    this.initRandomCount()

    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'low-small-recharge' })
  },
}
</script>

<style lang="scss" scoped>
.recharge-first {
  width: 375px;
  min-height: 100vh;
  background: linear-gradient(176deg, #ffd770 0%, #feedc2 100%);
  .custom-nav-block {
    background: linear-gradient(176deg, #ffd770 0%, #feedc2 100%) left top / 100% 100vh no-repeat;
  }

  .recharge-content {
    position: relative;
    .rec-fir-tit {
      display: block;
      width: 375px;
      height: 102px;
      margin: 12px auto 0;
    }

    .rec-date-block {
      position: relative;
      margin: -28px 0 0 28px;
      .rec-fir-date {
        padding: 0 16px;
        background: #ffffff;
        border-radius: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        span {
          font-family: 'Roboto-Regular';
          font-size: 17px;
          color: #ff8800;
          text-align: left;
        }

        img {
          width: 28px;
          height: 28px;
          margin: 0 6px;
        }
      }
    }

    .rec-fir-con {
      width: 343px;
      margin: 24px auto 0;
      padding: 10px;
      background: #ffd766;
      border-radius: 36px;
      .rec-fir-head {
        width: 100%;
        margin: 10px 0;
        font-family: 'Roboto-Regular';
        font-weight: bold;
        font-style: italic;
        font-size: 20px;
        line-height: 24px;
        text-align: center;

        color: #333333;
        text-shadow: 2px 0 #ffffff, -2px 0 #ffffff, 0 2px #ffffff, 0 -2px #ffffff, 2px 2px #ffffff, -2px -2px #ffffff, 2px -2px #ffffff,
          -2px 2px #ffffff;
      }
      .rec-fir-block {
        height: 100%;
        padding: 16px;
        background: #ffffff;
        border-radius: 36px;

        .rec-fir-reward {
          display: flex;
          justify-content: space-between;
          position: relative;
          .fir-reward-l {
            margin-top: 30px;
            padding-bottom: 48px;
            width: 130px;
            background: #fff9f4;
            border-radius: 16px;
            border: 1px solid #ffe0b5;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .fir-reward-num {
              font-family: 'Roboto-Regular';
              font-size: 24px;
              font-weight: bold;
              color: #333333;
              line-height: 28px;
              margin-top: 24px;
            }
            .fir-reward-coin {
              width: 32px;
              height: 32px;
              margin-top: 6px;
            }
            .fir-reward-tit {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 130px;
              height: 32px;
              background: #fff1d8;
              border-radius: 0px 0px 16px 16px;
              display: flex;
              align-items: center;
              justify-content: center;

              font-family: 'Roboto-Regular';
              font-size: 17px;
              color: #8e390d;
              line-height: 20px;
              margin-top: 16px;
            }
          }
          .fir-reward-c {
            width: 50px;
            height: 34px;
            position: absolute;
            top: 76px;
            left: 50%;
            z-index: 99;
            margin-left: -25px;
          }
          .fir-reward-r {
            margin-top: 20px;
            padding-bottom: 48px;
            width: 130px;
            background: #fef9e5;
            border-radius: 16px;
            border: 1px solid #ffe0b5;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .fir-reward-num {
              font-family: 'Roboto-Regular';
              font-size: 24px;
              font-weight: bold;
              color: #333333;
              line-height: 28px;
              margin-top: 24px;
              i {
                color: #ff0000;
                font-size: 24px;
              }
            }
            .fir-reward-coin {
              width: 32px;
              height: 32px;
              margin-top: 6px;
            }
            .fir-reward-tit {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 130px;
              height: 32px;
              background: #8e390d;
              border-radius: 0px 0px 16px 16px;
              display: flex;
              align-items: center;
              justify-content: center;

              font-family: 'Roboto-Regular';
              font-size: 17px;
              color: #ffffff;
              line-height: 20px;
              margin-top: 16px;
            }

            .reward-percent {
              position: absolute;
              top: 0;
              margin-top: -18px;

              width: 70px;
              height: 32px;
              padding: 6px 12px;
              background: #ff3420;
              border-radius: 27px;
              display: flex;
              align-items: center;
              justify-content: center;

              font-family: 'Roboto-Regular';
              font-weight: bold;
              font-size: 17px;
              color: #ffffff;
              font-style: italic;
            }
          }
        }

        .rec-fir-deliver {
          margin-top: 24px;
          font-family: 'Roboto-Regular';
          font-size: 17px;
          color: #333333;
          height: 20px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          .deliver-l,
          .deliver-r {
            flex: 1;
            position: relative;
            opacity: 0.5;
          }
          .deliver-l {
            div {
              width: 100%;
              height: 1px;
              background: linear-gradient(270deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
            }
          }
          .deliver-r {
            div {
              width: 100%;
              height: 1px;
              background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #333333 100%);
            }
          }
          .rec-fir-deliver-text {
            margin: 0 3px;
          }
        }

        .rec-fir-fecture {
          margin-top: 24px;
          padding: 0 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          .fir-fecture-gap {
            width: 40px;
          }
          .fir-fecture-item {
            display: flex;
            align-items: center;
            gap: 8px;
            img {
              width: 30px;
              height: 30px;
            }
            div {
              font-family: 'Roboto-Regular';
              font-size: 20px;
              color: #333333;
            }
          }
        }
      }
    }
  }

  .rec-fir-btn {
    width: 283px;
    height: 54px;
    margin: 40px auto 0;
    background: linear-gradient(180deg, #ff9185 0%, #ff3420 100%);
    border-radius: 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: 'InterTight';
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;

    .btn-icon {
      width: 35px;
      height: 35px;
      margin: 0 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }
  .cannot-claim {
    pointer-events: none;
    background: #dbdbdb;
    color: #999999;
  }
  .rec-fir-tip {
    width: 100%;
    padding: 0 16px 40px;
    font-family: 'Roboto-Regular';
    font-size: 15px;
    color: #333333;
    line-height: 18px;
    margin-top: 12px;
    li {
      width: 100%;
      text-align: center;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .recharge-first .recharge-content .rec-fir-con .rec-fir-block .rec-fir-reward .fir-reward-c {
    transform: rotateY(180deg);
  }

  .recharge-first .recharge-content .rec-date-block {
    margin: -28px 28px 0 0;
  }
}
</style>
